export const SHOP_ADMINISTRATION_USERS_URL = `shop-administration/users`;
